module.exports = __webpack_public_path__ + "static/media/Document.02a8a1dc.svg";